
  import { Vue, Component } from "vue-property-decorator";
  import { IPaginationSet, IPhishFinderModel } from "@/models";
  import { BlackListService, OpenRequestService } from "@/services/admin";
  import {
    ValidationObserver,
    ValidationProvider
  } from "vee-validate/dist/vee-validate.esm.js";
  import UserComment from "./UserComment.vue";
  import UserOpenRequest from "./UserOpenRequest.vue";
  import dayjs from "dayjs";

  @Component({
    name: "PhishFinder",
    components: {
      UserComment,
      UserOpenRequest,
      ValidationObserver,
      ValidationProvider
    }
  })
  export default class PhishFinder extends Vue {
    fields: any[] = [
      {
        key: "selected",
        label: "",
        tdClass: "columnLookup"
      },
      {
        key: "emailFrom",
        label: "Domain/Email"
      },
      {
        key: "lastSent",
        label: "Last Sent"
      },
      {
        key: "dateBlackListed",
        label: "Blacklist Date"
      },
      {
        key: "action",
        label: "Blacklist"
      }
    ];
    addNewMail: string = "";
    showComment: boolean = false;
    isLoading: boolean = true;
    selectAll: boolean = false;
    days: number = 30;
    result?: Array<IPhishFinderModel>;
    currentUser?: IPhishFinderModel = {} as IPhishFinderModel;
    radioSelected: string = "PhishFinder";
    $refs!: {
      userCommentsRef: any;
      form: InstanceType<typeof ValidationObserver>;
    };

    constructor() {
      super();
      this.isLoading = true;
      this.result = [] as Array<IPhishFinderModel>;
    }

    created() {
      setTimeout(() => {
        // wait for 500ms since vue router not finish
        // call this.$Progress.finish();
        this.loadData();
      }, 500);
    }
    onRadioButtonChange() {
      this.loadData();
    }

    onSearch() {
      this.loadData();
    }
    async loadData() {
      this.isLoading = true;
      this.$Progress.start();
      const response = await BlackListService.GetPhishFinder(
        this.days,
        this.radioSelected === "Blacklist"
      );
      if (response.status === 200) {
        response.data.map(el => {
          el.selected = false;
          return el;
        });
        this.result = response.data;
      } else {
        this.generateError("Failed when loading data from server");
      }
      this.isLoading = false;
      this.$Progress.finish();
    }

    onDelete(ad: IPhishFinderModel) {
      this.currentUser = ad;
      this.$bvModal.show("delete-email-modal");
    }
    async onAdd(ad: IPhishFinderModel) {
      try {
        await BlackListService.Add(ad.emailFrom);
        this.generateSuccess(
          `Successfully add ${ad.emailFrom} to blacklist email`
        );
        this.loadData();
      } catch (err) {
        this.generateError(`Failed to add ${ad.emailFrom} to blacklist email`);
      }
    }
    async addNewBlacklist() {
      const { isValid, errors } = await this.$refs.form.validateWithInfo();
      if (!isValid) {
        const length = Object.keys(errors).length;
        for (var i = 0; i < length; i++) {
          const errorFieldName = Object.keys(errors)[i];
          if (errors[errorFieldName].length > 0) {
            this.$refs[errorFieldName].focus();
            this.generateError(errors[errorFieldName][0]);
            break;
          }
        }

        return false;
      }

      try {
        await BlackListService.Add(this.addNewMail);
        this.generateSuccess(
          `Successfully add ${this.addNewMail} to blacklist email`
        );
        this.loadData();
      } catch (err) {
        this.generateError(
          `Failed to add ${this.addNewMail} to blacklist email`
        );
      }
      this.addNewMail = "";
    }
    onDeleteAll() {
      this.$bvModal.show("delete-all-email-modal");
    }
    onSelectAll() {
      const items = this.result;
      items.map(el => {
        el.selected = this.selectAll;
        return el;
      });
      this.result = [...items];
    }
    handleDelete() {
      const index = this.result.findIndex(
        el => el.emailFrom === this.currentUser.emailFrom
      );
      try {
        BlackListService.Delete(this.currentUser.emailFrom);
        this.result[index].dateBlackListed = null;
        this.generateSuccess(
          `Successfully delete ${this.currentUser.emailFrom}`
        );
        this.$bvModal.show("user-request-modal");
      } catch (err) {
        this.generateError(err.message);
      }
    }
    getPostingDate(date: string) {
      if (date !== "") {
        return dayjs(date).format("MM/DD/YYYY");
      }

      return "";
    }
    getPostingTime(date: string) {
      if (date !== "") {
        return dayjs(date).format("hh:mm A");
      }
      return "";
    }
    async onDeleteAllHandle() {
      const emails: Array<string> = [];
      this.result.forEach(el => {
        if (el.selected === true) {
          emails.push(el.emailFrom);
        }
      });
      if (emails.length === 0) {
        return false;
      }
      this.$bvModal.hide("delete-all-email-modal");
      this.$mainLoader.show();
      try {
        await OpenRequestService.DeleteMultiple(emails);
        this.generateSuccess(`Successfully to delete selected emails`);
        this.loadData();
      } catch (err) {
        this.generateError(err.message);
      }
      this.$mainLoader.hide();
    }
    generateError(msg: string) {
      this.$bvToast.toast(`Error: ${msg}`, {
        title: "Error",
        variant: "danger",
        autoHideDelay: 5000
      });
    }
    generateSuccess(msg: string) {
      this.$bvToast.toast(`${msg}`, {
        title: "Information",
        variant: "primary",
        autoHideDelay: 5000
      });
    }

    lookupUrl(email: string) {
      var host = location.host.includes("localhost")
        ? "dev.vin.com"
        : location.host;
      return `https://${host}/admin/intranet/Client.asp?Page=SearchClient&Email=${email}`;
    }

    userComment(event: MouseEvent, email: string) {
      event.preventDefault();
      this.$refs.userCommentsRef.onLoad(email);
      this.showComment = true;
    }

    onBackToBlacklist() {
      this.showComment = false;
    }
  }
